import mailStore from 'owa-mail-store/lib/store/Store';
export function getItem(itemId) {
    return mailStore.items.get(itemId);
}
//# sourceMappingURL=getItem.js.map